(() => {
  const TARGET_WIDTH = 1365;
  const DARK_EARTH_PATH = '/collections/dark-earth-tone-dresses';
  const PRODUCT_IMAGE_SELECTOR = [
    '.product-card-wrapper .card__media img',
    'media-gallery .product__media img'
  ].join(',');

  const originalSizedUrl = (url) => {
    if (!url) return null;

    const parsed = new URL(url, window.location.origin);
    if (!parsed.pathname.includes('/cdn/shop/')) return null;

    parsed.searchParams.set('width', String(TARGET_WIDTH));
    return parsed.toString();
  };

  const sharpenImageRequest = (image) => {
    if (!image.matches(PRODUCT_IMAGE_SELECTOR)) return;

    const targetUrl = originalSizedUrl(image.currentSrc || image.src);
    if (!targetUrl) return;
    if (image.src === targetUrl && !image.hasAttribute('srcset') && !image.hasAttribute('sizes')) return;

    image.dataset.storewideSharp = 'true';
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = targetUrl;
  };

  const sharpenAll = (root = document) => {
    if (root instanceof HTMLImageElement) sharpenImageRequest(root);
    root.querySelectorAll?.(PRODUCT_IMAGE_SELECTOR).forEach(sharpenImageRequest);
  };

  const start = () => {
    if (window.location.pathname === DARK_EARTH_PATH) {
      const title = document.querySelector('h1.collection-hero__title');
      if (title) {
        title.style.setProperty('font-family', 'var(--font-body-family)');
        title.style.setProperty('font-size', window.matchMedia('(min-width: 750px)').matches ? '2.8rem' : '2.2rem');
        title.style.setProperty('font-style', 'var(--font-body-style)');
        title.style.setProperty('font-weight', '500');
        title.style.setProperty('letter-spacing', '0.03em');
        title.style.setProperty('line-height', '1.25');
        title.style.setProperty('text-align', 'left');
      }
    }

    sharpenAll();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
          sharpenImageRequest(mutation.target);
        }
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) sharpenAll(node);
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'sizes']
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
